<template>
  <div class="page-nav-header" :class="{ 'page-nav-header--mobile': isMobile }">
    <div v-if="isMobile" class="page-nav-header__bar">
      <button type="button" class="page-nav-header__back" @click="handleBack">
        <i class="el-icon-arrow-left"></i>
        <span>返回</span>
      </button>
      <div class="page-nav-header__bar-title">{{ title }}</div>
      <div class="page-nav-header__bar-placeholder"></div>
    </div>
    <div v-else class="page-nav-header__desktop">
      <h2 class="page-nav-header__title">{{ title }}</h2>
    </div>
    <div v-if="$slots.extra" class="page-nav-header__extra">
      <slot name="extra"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageNavHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    backTo: {
      type: String,
      default: '/Home'
    }
  },
  computed: {
    isMobile() {
      return this.detectDevice() === 'mobile'
    }
  },
  methods: {
    handleBack() {
      if (this.$listeners.back) {
        this.$emit('back')
        return
      }
      this.$router.push(this.backTo)
    }
  }
}
</script>

<style scoped>
.page-nav-header {
  margin-bottom: 16px;
}

.page-nav-header__desktop {
  padding-bottom: 12px;
  border-bottom: 1px solid #ebeef5;
}

.page-nav-header__title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  line-height: 1.4;
}

.page-nav-header__bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0 12px;
  border-bottom: 1px solid #ebeef5;
}

.page-nav-header__back {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  min-width: 64px;
  min-height: 36px;
  padding: 0 8px 0 0;
  border: none;
  background: transparent;
  color: #1d63ff;
  font-size: 15px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.page-nav-header__back:active {
  opacity: 0.7;
}

.page-nav-header__back i {
  font-size: 18px;
  font-weight: bold;
}

.page-nav-header__bar-title {
  flex: 1;
  text-align: center;
  font-size: 17px;
  font-weight: 600;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 8px;
}

.page-nav-header__bar-placeholder {
  min-width: 64px;
}

.page-nav-header__extra {
  margin-top: 10px;
  font-size: 13px;
  color: #909399;
  line-height: 1.6;
}

.page-nav-header--mobile .page-nav-header__extra {
  margin-top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/PageNavHeader.vue